import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

export const Button = ({ children, type, as, className, ...props }) => {
  const Component = as || "div"
  return (
    <Component className={cn(className, styles.Button)} type={type} {...props}>
      {children}
    </Component>
  )
}
